const IMAGE_PRELOAD = {
    TYPE: {
        LOGOS: "LOGOS",
        PRINCIPLES: "PRINCIPLES",
        TESTIMONIALS: "TESTIMONIALS",
        CREDENTIALS: "CREDENTIALS"
    }
}

export default IMAGE_PRELOAD;